'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createEventPool = exports.createQueue = exports.scheduleFlush = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _helpers = require('./common/helpers');

var _storageKeys = require('./storageKeys');

var PAGE_LOADED_TIME = Date.now();
var PAGE_LOAD_DEFER_TIMER = 6000;
var DEBOUNCE_TIMER = 2000;
var SERIALIZED_ARRAY = JSON.stringify([]);

var hasDeferredExecution = false;
var pageHasLoaded = false;

var getTimeSincePageLoad = function getTimeSincePageLoad() {
  return Date.now() - PAGE_LOADED_TIME;
};
var shouldDefer = function shouldDefer() {
  if (pageHasLoaded) {
    return false;
  }
  return getTimeSincePageLoad() < PAGE_LOAD_DEFER_TIMER;
};
var execute = function execute(callback) {
  return callback();
};
var deferredExecution = function deferredExecution() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (hasDeferredExecution) {
    return;
  }

  setTimeout(function () {
    execute.apply(undefined, args);
    pageHasLoaded = true;
  }, PAGE_LOAD_DEFER_TIMER - getTimeSincePageLoad());
  hasDeferredExecution = true;
};
var debouncedExecution = (0, _helpers.debounce)(execute, DEBOUNCE_TIMER);

var scheduleFlush = exports.scheduleFlush = function scheduleFlush() {
  if (shouldDefer()) {
    deferredExecution.apply(undefined, arguments);
  } else {
    debouncedExecution.apply(undefined, arguments);
  }
};

/*
 * The event pool utilizes a queue under the hood
 * for it's first-in-first-out functionality.
 */
var createQueue = exports.createQueue = function createQueue() {
  var queue = [];
  return {
    enqueue: function enqueue(event) {
      return queue.unshift(event);
    },
    dequeue: function dequeue() {
      return queue.shift();
    },
    peek: function peek() {
      return queue[0];
    }
  };
};

var createEventPool = exports.createEventPool = function createEventPool(_ref) {
  var getTempStorage = _ref.getTempStorage,
      setTempStorage = _ref.setTempStorage;

  var isInitialized = false;
  var eventQueue = createQueue();

  return {
    getIsInitialized: function getIsInitialized() {
      return isInitialized;
    },

    initialize: function initialize(_ref2) {
      var normalizeEvent = _ref2.normalizeEvent;

      try {
        var storedEvents = getTempStorage(_storageKeys.storageKey) || SERIALIZED_ARRAY;
        var parsedEvents = JSON.parse(storedEvents);

        if (parsedEvents && (0, _helpers.isArray)(parsedEvents)) {
          parsedEvents.forEach(function (event) {
            if (event && (typeof event === 'undefined' ? 'undefined' : _typeof(event)) === 'object') {
              eventQueue.enqueue(normalizeEvent(event));
            }
          });
        }

        isInitialized = true;
      } catch (err) {
        /* noOp */
      }
    },

    push: function push(event) {
      try {
        var storedEvents = getTempStorage(_storageKeys.storageKey) || SERIALIZED_ARRAY;
        var parsedEvents = JSON.parse(storedEvents);
        parsedEvents.push(event);
        setTempStorage(_storageKeys.storageKey, JSON.stringify(parsedEvents));
      } catch (err) {
        /* noOp */
      }

      eventQueue.enqueue(event);
    },

    flush: function flush() {
      var events = [];

      do {
        var event = eventQueue.dequeue();
        if (event) {
          events.unshift(event);
        }
      } while (eventQueue.peek());

      try {
        setTempStorage(_storageKeys.storageKey, SERIALIZED_ARRAY);
      } catch (err) {
        /* noOp */
      }

      return events;
    },

    peek: eventQueue.peek
  };
};